module.exports = {
      id: "pause-usage",
      viewBox: "0 0 31 30",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#pause",
      toString: function () {
        return this.url;
      }
    }